import {trpc} from '@features/utils/trpc';
import {useMutationState} from '@tanstack/react-query';
import {
  useIsAnyScreenGenerating,
  useIsScreenGenerating,
} from './streaming/useGeneration';

export const useAiThinkingForChat = (chatId: string | undefined | null) => {
  const pushChatMessage = trpc.generation.pushChatMessage.useMutation();
  const isGenerating = useIsScreenGenerating(chatId);

  const setActiveStructureMutationState = useMutationState({
    filters: {
      mutationKey: ['setActiveStructure', chatId],
      status: 'pending', // Filter to only show pending/loading mutations
    },
  });
  return (
    isGenerating ||
    !pushChatMessage.isIdle ||
    setActiveStructureMutationState.length > 0
  );
};

export function useAiThinking() {
  const pushChatMessage = trpc.generation.pushChatMessage.useMutation();
  const isGenerating = useIsAnyScreenGenerating();

  return isGenerating || !pushChatMessage.isIdle;
}
